import { useEffect } from 'react';
import { getVideoStream } from './useVideoSession';

/**
 * Adjunta el video de un usuario dentro de `shellRef` mientras `enabled` sea true.
 *
 * Al limpiar se desadjunta solo el reproductor propio: `detachVideo(userId)` sin
 * elemento apagaría también las otras vistas del mismo usuario (p. ej. el
 * escenario principal y su tarjeta en el tab «En vivo»).
 */
export const useAttachedVideo = (shellRef, userId, { enabled, quality, className }) => {
    useEffect(() => {
        const stream = getVideoStream();
        const shell = shellRef.current;
        if (!enabled || !stream || !shell || userId == null) return undefined;

        let cancelled = false;
        let player = null;
        const container = document.createElement('video-player-container');
        if (className) container.className = className;
        shell.appendChild(container);

        const detach = (el) => {
            stream.detachVideo(userId, el).catch(() => { /* ignore */ });
        };

        stream.attachVideo(userId, quality)
            .then((el) => {
                if (!(el instanceof Node)) {
                    console.warn('[VideoSDK] attachVideo:', el?.reason || el);
                    return;
                }
                if (cancelled) {
                    detach(el);
                    return;
                }
                player = el;
                container.appendChild(el);
            })
            .catch((err) => {
                console.warn('[VideoSDK] attachVideo:', err?.message || err);
            });

        return () => {
            cancelled = true;
            if (player) detach(player);
            container.remove();
        };
    }, [shellRef, userId, enabled, quality, className]);
};
